import {useContext} from 'react';
import {useParams} from 'react-router-dom';
import {UserApplications} from '../../../../../../../components/user-applications/user-applications';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {ScreenPaths} from '../../../../../../../enums/screen-path';

export default function CaregiverApplicationsSystemAdministratorOfficeScreen() {
  // Get context
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // Get params
  let {id}: {id?: string} = useParams();

  return (
    <UserApplications
      caregiverMode={CaregiverMode.SystemAdministrator}
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      applicationRowBaseLinkUrl={`${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}${ScreenPaths.SystemAdministrator_Applications}`}
      canWrite
    />
  );
}
